import api from "./api";

export const getsSesionResumenView = async (filters) => {
    const response = await api.get('/Sesion/GetsSesionResumenView?'
            + 'idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
            + '&participante=' + (filters.participante == null ? "" : filters.participante)
            + '&idPeriodo=' + (filters.idPeriodo == null ? 0 : filters.idPeriodo)
            + '&fechaInicio=' + (filters.fechaInicio == null ? "" : filters.fechaInicio)
            + '&fechaFin=' + (filters.fechaFin == null ? "" : filters.fechaFin)
            + '&idEstado=' + (filters.idEstado == null ? "" : filters.idEstado)
        );

    return response.data.data;
}

export const annulSesion = (idSesion) =>
    api.post("/Sesion/AnnulSesion?idSesion=" + idSesion);

export const activeSesion = (idSesion) =>
    api.post("/Sesion/ActiveSesion?idSesion=" + idSesion);

export const addUpdateSessionWithDetails = (dataPost) =>
    api.post("/Sesion/AddUpdateSessionWithDetails", dataPost);

export const getsSesionTerapeutaView = async (idSesion) => {
    const response = await api.get("/Sesion/GetsSesionTerapeutaView?idSesion=" + idSesion);

    return response.data.data;
}

export const getsSesionCriterioView = async (idSesion) => {
    const response = await api.get("/Sesion/GetsSesionCriterioView?idSesion=" + idSesion);

    return response.data.data;
}

export const validarSesion = (idSesion) =>
    api.post("/Sesion/ValidarSesion?idSesion=" + idSesion);

export const desvalidarSesion = (idSesion) =>
    api.post("/Sesion/DesvalidarSesion?idSesion=" + idSesion);

export const getsSesionPlanillaView = async (filters) => {
    const response = await api.get('/Sesion/GetsSesionPlanillaView?'
            + 'idTerapeuta=' + (filters.idTerapeuta == null ? 0 : filters.idTerapeuta)
            + '&idPeriodo=' + (filters.idPeriodo == null ? 0 : filters.idPeriodo)
            + '&idFilial=' + (filters.idFilial == null ? 0 : filters.idFilial)
        );

    return response.data.data;
}
